/**
 * Composable for fetching and transforming product gallery images from an ordered product.
 *
 * @param {string} product - The unique identifier of the product.
 * @returns {UseFetchReturn} A fetch result with transformed gallery images.
 * @example
 * // Fetch gallery images for a specific product
 * const { data: galleryImages } = useOrderedGallery('product123')
 */
export const useOrderedGallery = (product: string) => {
  const configs = useAppConfig()
  const algoliaIndex = configs.currentAlgoliaIndex

  return useFetch(`/api/getProduct/${algoliaIndex}/${product}`, {
    transform: algoliaProduct => getOrderedGallery(algoliaProduct.assets),
  })
}
